<template>
  <div id="defaultEventDetail">
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="getLoadingDetail"
    ></v-progress-linear>

    <transition-group name="card-in-out">
      <v-card
        class="event-card-detail"
        elevation="1"
        v-for="(object, index) in getEventsDetail"
        :key="object.event.source"
        v-if="!checkIsMobile() && !checkIsTablet()"
      >
        <div class="event-card-header sticky" id="header-detail">
          <span class="sport-text" :title="object.sport.name">
            <img
              v-if="object.type == 'antepost'"
              :src="sportPath + 'antepost.svg'"
              :alt="'Antepost' + object.sport.name"
            />
            <img
              v-else
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
            {{ object.sport.name }}
          </span>

          <span class="category-text" :title="object.category.name">
            <v-icon dense>mdi-chevron-right</v-icon>
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
            {{ object.category.name }}
          </span>

          <span
            :class="[
              'tournament-text',
              object.event.type == 'antepost' ? 'highlight' : 'equal',
            ]"
            :title="object.tournament.name"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.tournament.name }}
          </span>

          <span
            class="desc-event highlight"
            :title="object.event.description"
            v-if="object.event.type == 'match'"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.event.description }}
          </span>

          <span
            class="close-card cursor-pointer"
            @click="removeDetail(object.event.source, object.event.type)"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.7699 1.33324L6.99991 5.11324L3.22991 1.33324C2.9784 1.08173 2.63727 0.94043 2.28158 0.94043C1.92588 0.94043 1.58476 1.08173 1.33324 1.33324C1.08173 1.58476 0.94043 1.92588 0.94043 2.28158C0.94043 2.63727 1.08173 2.9784 1.33324 3.22991L5.11324 6.99991L1.33324 10.7699C1.08173 11.0214 0.94043 11.3625 0.94043 11.7182C0.94043 12.0739 1.08173 12.4151 1.33324 12.6666C1.58476 12.9181 1.92588 13.0594 2.28158 13.0594C2.63727 13.0594 2.9784 12.9181 3.22991 12.6666L6.99991 8.88658L10.7699 12.6666C11.0214 12.9181 11.3625 13.0594 11.7182 13.0594C12.0739 13.0594 12.4151 12.9181 12.6666 12.6666C12.9181 12.4151 13.0594 12.0739 13.0594 11.7182C13.0594 11.3625 12.9181 11.0214 12.6666 10.7699L8.88658 6.99991L12.6666 3.22991C12.7911 3.10537 12.8899 2.95753 12.9573 2.79481C13.0247 2.63209 13.0594 2.4577 13.0594 2.28158C13.0594 2.10545 13.0247 1.93106 12.9573 1.76834C12.8899 1.60563 12.7911 1.45778 12.6666 1.33324C12.542 1.20871 12.3942 1.10992 12.2315 1.04252C12.0688 0.97512 11.8944 0.94043 11.7182 0.94043C11.3625 0.94043 11.0214 1.08173 10.7699 1.33324Z"
              />
            </svg>
          </span>
        </div>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPath +
            object.sport.id +
            '.webp\');height: 90px;background-size: cover;'
          "
          v-if="object.event.type == 'match'"
        >
          <v-col cols="12" md="5" class="no-padding align-middle flex-end">
            <div class="competitor">
              <div class="name">{{ object.event.competitors.home.name }}</div>
            </div>
          </v-col>

          <v-col cols="12" md="2" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time">
                {{
                  new Date(object.event.scheduled).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                }}
              </span>
              <span class="day">{{ object.event.day }}</span>
              <span
                v-if="
                  getUserType == 4 ||
                  getCashier ||
                  !getSettings.enableQuickBetOnlyForAgency
                "
                class="event-qbet"
                title="qbet"
              >
                {{ object.event.quickbet }}
              </span>
            </div>
          </v-col>

          <v-col cols="12" md="5" class="no-padding align-middle flex-start">
            <div class="competitor away">
              <div class="name">{{ object.event.competitors.away.name }}</div>
            </div>
          </v-col>
        </v-row>

        <v-row
          class="event-card-intro no-padding no-margin"
          :style="'background: #3a3a3a;height: 110px;'"
          v-else-if="object.event.type == 'antepost'"
        >
          <v-col cols="12" md="12" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time"> Antepost {{ object.tournament.name }} </span>
              <span class="day">
                {{ object.sport.name }} - {{ object.category.name }}
              </span>
            </div>
          </v-col>
        </v-row>

        <v-row class="no-padding no-margin" style="min-height: 900px">
          <v-col cols="12" v-if="object.event.type == 'match'">
            <v-tabs v-model="tab" grow class="tabs-list">
              <v-tab
                class="group-tab"
                v-for="group in object.groupMarkets"
                :key="group.id"
                @click="
                  getOddsGroup(
                    object.event.id,
                    group.group_id,
                    object.sport.id,
                    object.tournament.id ? object.tournament.id : ''
                  )
                "
              >
                {{ group.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="group in object.groupMarkets"
                :key="group.id + '-' + group.name"
              >
                <v-card color="basil" flat v-if="!tab_loading">
                  <masonry
                    :cols="3"
                    :gutter="20"
                    v-if="checkExists(object.event.odds)"
                  >
                    <div
                      v-for="(market, index) in object.event.odds"
                      :key="market.unique_id"
                      v-if="market.odds.length > 0 && checkLocked(market)"
                    >
                      <div class="market-box">
                        <div class="market-header">
                          {{ market.name_market }}
                          {{ market.specifiers != '' ? market.specifiers : '' }}
                        </div>
                        <div class="market-content">
                          <div
                            v-for="(odd, index) in market.odds"
                            :key="odd.unique_id"
                            v-if="
                              (odd.active ||
                                (market.showLocked && !odd.active)) &&
                              !odd.unique_id.includes('undefined')
                            "
                            @click="
                              putCart(
                                odd,
                                object.event,
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <div class="odd-button">
                              <div
                                :class="[
                                  'sign',
                                  getOddsSources.includes(odd.unique_id)
                                    ? 'odd_selected'
                                    : '',
                                ]"
                              >
                                {{ odd.outcome_name }}
                                {{ getSpecifiers(odd.market_unique_id) }}
                              </div>
                              <div
                                v-if="odd.outcome_odd_value > 1.0 && odd.active"
                                :class="[
                                  'value',
                                  'multi-' + market.multiplicity_min,
                                  odd.type_change != undefined
                                    ? odd.type_change
                                    : 'equal',
                                  getOddsSources.includes(odd.unique_id)
                                    ? 'odd_selected'
                                    : '',
                                ]"
                              >
                                <v-icon
                                  class="arrow-up"
                                  v-if="odd.type_change == 'up'"
                                >
                                  mdi-arrow-up
                                </v-icon>
                                <v-icon
                                  class="arrow-down"
                                  v-if="odd.type_change == 'down'"
                                  >mdi-arrow-down
                                </v-icon>
                                {{ odd.outcome_odd_value | odds_type_filter }}
                              </div>
                              <div
                                v-else
                                class="value"
                                :class="'multi-' + market.multiplicity_min"
                              >
                                <v-icon dense>mdi-lock</v-icon>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </masonry>
                  <div v-else>
                    <h3 class="no-odds-message">
                      <v-icon large>mdi-trophy-variant-outline</v-icon>
                      <br />{{ $t('noOddsForThisGroup') }}
                    </h3>
                  </div>
                </v-card>
                <v-card v-else>
                  <v-skeleton-loader
                    v-bind="attrs"
                    type="date-picker"
                  ></v-skeleton-loader>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-col cols="12" v-else-if="object.event.type == 'antepost'">
            <v-card color="basil" flat v-if="!tab_loading">
              <masonry :cols="1" :gutter="20">
                <div
                  v-for="(market, index) in object.event.odds"
                  :key="market.unique_id"
                  v-if="
                    market.showMarket &&
                    market.odds.length > 0 &&
                    isActiveMarket(market.odds)
                  "
                >
                  <div class="market-box">
                    <div class="market-header">
                      {{ market.name_market }}
                      {{ market.specifiers != '' ? market.specifiers : '' }}
                    </div>
                    <div class="market-content row">
                      <div
                        v-for="(odd, index) in market.odds"
                        :key="odd.unique_id"
                        v-if="
                          (odd.active || (market.showLocked && !odd.active)) &&
                          !odd.unique_id.includes('undefined')
                        "
                        @click="
                          putCart(
                            odd,
                            object.event,
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                        class="col-4"
                      >
                        <div class="odd-button">
                          <div
                            :class="[
                              'sign',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            {{ odd.outcome_name }}
                            {{ getSpecifiers(odd.market_unique_id) }}
                          </div>
                          <div
                            v-if="odd.outcome_odd_value > 1.0 && odd.active"
                            :class="[
                              'value',
                              'multi-' + market.multiplicity_min,
                              odd.type_change != undefined
                                ? odd.type_change
                                : 'equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            <v-icon
                              class="arrow-up"
                              v-if="odd.type_change == 'up'"
                            >
                              mdi-arrow-up
                            </v-icon>
                            <v-icon
                              class="arrow-down"
                              v-if="odd.type_change == 'down'"
                            >
                              mdi-arrow-down
                            </v-icon>
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + market.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </masonry>
            </v-card>
            <v-card v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="date-picker"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        class="event-card-detail detail-mobile"
        elevation="1"
        v-for="(object, index) in getEventsDetail"
        :key="object.event.source"
        v-else-if="checkIsMobile() || checkIsTablet()"
      >
        <div class="event-card-header">
          <span class="sport-text" :title="object.sport.name">
            <img
              v-if="object.type == 'antepost'"
              :src="sportPath + 'antepost.svg'"
              :alt="'Antepost' + object.sport.name"
            />
            <img
              v-else
              :src="sportPath + object.sport.id + '.svg'"
              :alt="object.sport.name"
              v-bind:class="{ 'img-sport-light': light }"
            />
            <!--            {{ object.sport.name }}-->
          </span>

          <span class="category-text" :title="object.category.name">
            <!--            <v-icon dense>mdi-chevron-right</v-icon>-->
            <img
              :src="categoryPath + object.category.id + '.svg'"
              :alt="object.category.name"
            />
            <!--            {{ object.category.name }}-->
          </span>

          <span
            :class="[
              'tournament-text',
              object.event.type == 'antepost' ? 'highlight' : 'equal',
            ]"
            :title="object.tournament.name"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.tournament.name }}
          </span>

          <span
            class="desc-event highlight"
            :title="object.event.description"
            v-if="object.event.type == 'match'"
          >
            <v-icon dense>mdi-chevron-right</v-icon>
            {{ object.event.description }}
          </span>

          <span class="close-card">
            <v-icon
              dense
              @click="removeDetail(object.event.source, object.event.type)"
              >mdi-close-box</v-icon
            >
          </span>
        </div>
        <v-row
          class="event-card-intro no-padding no-margin"
          :style="
            'background-image: url(\'' +
            sportBackgroundPath +
            object.sport.id +
            '.webp\');background-position: bottom;'
          "
          v-if="object.event.type == 'match'"
        >
          <v-col xs="2" class="align-middle">
            <div class="competitor">
              <!--              <div class="flag" :title="object.event.competitors.home.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.home.id+'.png'"-->
              <!--                     :alt="object.event.competitors.home.name">-->
              <!--              </div>-->
              <div class="name">{{ object.event.competitors.home.name }}</div>
            </div>
          </v-col>

          <v-col xs="8" class="align-middle flex-center">
            <div class="match-date">
              <span class="time">
                {{
                  new Date(object.event.scheduled).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                  })
                }}
              </span>
              <span class="day">{{ object.event.day }}</span>
            </div>
          </v-col>

          <v-col xs="2" class="align-middle flex-end">
            <div class="competitor away">
              <!--              <div class="flag" :title="object.event.competitors.away.name">-->
              <!--                <img :src="flagTeamsPath+object.event.competitors.away.id+'.png'"-->
              <!--                     :alt="object.event.competitors.away.name">-->
              <!--              </div>-->
              <div class="name">{{ object.event.competitors.away.name }}</div>
            </div>
          </v-col>
        </v-row>

        <v-row
          class="event-card-intro no-padding no-margin"
          :style="'background: #3a3a3a;height: 110px;'"
          v-else-if="object.event.type == 'antepost'"
        >
          <v-col cols="12" md="12" class="no-padding align-middle flex-center">
            <div class="match-date">
              <span class="time"> Antepost {{ object.tournament.name }} </span>
              <span class="day">
                {{ object.sport.name }} - {{ object.category.name }}
              </span>
            </div>
          </v-col>
        </v-row>

        <v-row class="no-padding no-margin">
          <v-col cols="12" v-if="object.event.type == 'match'">
            <v-slide-group show-arrows class="pt-2 pb-2" active-class="success">
              <v-slide-item
                v-for="group in object.groupMarkets"
                :key="$uuid.v1()"
              >
                <v-btn
                  small
                  class="mx-2"
                  depressed
                  rounded
                  @click="
                    getOddsGroup(
                      object.event.id,
                      group.group_id,
                      object.sport.id,
                      object.tournament.id ? object.tournament.id : ''
                    )
                  "
                  :class="
                    groupSelected == group.group_id ? 'group-odds-active' : ''
                  "
                >
                  <span class="text-sport text-capitalize">
                    {{ group.name }}</span
                  >
                </v-btn>
              </v-slide-item>
            </v-slide-group>
            <v-card
              color="basil"
              flat
              v-if="!tab_loading"
              class="group-odds-mobile"
            >
              <masonry :cols="1" :gutter="20">
                <div
                  v-for="(market, index) in object.event.odds"
                  :key="market.unique_id"
                  v-if="market.odds.length > 0 && checkLocked(market)"
                >
                  <div class="market-box">
                    <div class="market-header">
                      {{ market.name_market }}
                      {{ market.specifiers != '' ? market.specifiers : '' }}
                    </div>
                    <div class="market-content">
                      <div
                        v-for="(odd, index) in market.odds"
                        :key="odd.unique_id"
                        v-if="
                          (odd.active || (market.showLocked && !odd.active)) &&
                          !odd.unique_id.includes('undefined')
                        "
                        @click="
                          putCart(
                            odd,
                            object.event,
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                      >
                        <div class="odd-button">
                          <div
                            :class="[
                              'sign',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            {{ odd.outcome_name }}
                            {{ getSpecifiers(odd.market_unique_id) }}
                          </div>
                          <div
                            v-if="odd.outcome_odd_value > 1.0 && odd.active"
                            :class="[
                              'value',
                              'multi-' + market.multiplicity_min,
                              odd.type_change != undefined
                                ? odd.type_change
                                : 'equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            <v-icon
                              class="arrow-up"
                              v-if="odd.type_change == 'up'"
                            >
                              mdi-arrow-up
                            </v-icon>
                            <v-icon
                              class="arrow-down"
                              v-if="odd.type_change == 'down'"
                            >
                              mdi-arrow-down
                            </v-icon>
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + market.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </masonry>
            </v-card>
            <v-card v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="date-picker"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
          <v-col cols="12" v-else-if="object.event.type == 'antepost'">
            <v-card
              color="basil"
              flat
              v-if="!tab_loading"
              class="group-odds-mobile"
            >
              <masonry :cols="1" :gutter="20">
                <div
                  v-for="(market, index) in object.event.odds"
                  :key="market.unique_id"
                  v-if="
                    market.showMarket &&
                    market.odds.length > 0 &&
                    isActiveMarket(market.odds)
                  "
                >
                  <div class="market-box">
                    <div class="market-header">
                      {{ market.name_market }}
                      {{ market.specifiers != '' ? market.specifiers : '' }}
                    </div>
                    <div class="market-content row pb-2 pt-2">
                      <div
                        v-for="(odd, index) in market.odds"
                        :key="odd.unique_id"
                        v-if="
                          (odd.active || (market.showLocked && !odd.active)) &&
                          !odd.unique_id.includes('undefined')
                        "
                        @click="
                          putCart(
                            odd,
                            object.event,
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                        class="col-12 pb-0 pt-0"
                      >
                        <div class="odd-button">
                          <div
                            :class="[
                              'sign',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            {{ odd.outcome_name }}
                            {{ getSpecifiers(odd.market_unique_id) }}
                          </div>
                          <div
                            v-if="odd.outcome_odd_value > 1.0 && odd.active"
                            :class="[
                              'value',
                              'multi-' + market.multiplicity_min,
                              odd.type_change != undefined
                                ? odd.type_change
                                : 'equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                          >
                            <v-icon
                              class="arrow-up"
                              v-if="odd.type_change == 'up'"
                            >
                              mdi-arrow-up
                            </v-icon>
                            <v-icon
                              class="arrow-down"
                              v-if="odd.type_change == 'down'"
                            >
                              mdi-arrow-down
                            </v-icon>
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + market.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </masonry>
            </v-card>
            <v-card v-else>
              <v-skeleton-loader
                v-bind="attrs"
                type="date-picker"
              ></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '../../../plugins/device-inspector'
// import _ from "lodash";

export default {
  name: 'DefaultEventDetail',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    groupSelected: 0,
    tab: null,
    tab_loading: false,
    loading: false,
    antepostType: ['stage', 'season', 'simple_tournament'],
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT+'/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    flagTeamsPath: process.env.VUE_APP_URL_FLAG_TEAMS_CLOUDFRONT + '/medium/',
    // sportBackgroundPath: process.env.VUE_APP_URL_SIRPLAY_CLOUDFRONT + '/platform/elements/background/',
    sportBackgroundPath:
      'https://rocky-revenge.s3.eu-west-1.amazonaws.com/svg/sports-bg/',
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getEventsDetail: 'odds/getEventsDetail',
      getLoadingDetail: 'odds/getLoadingDetail',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getPlatformId: 'settings/getPlatformId',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
    }),
  },
  methods: {
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromDetail: 'odds/removeFromDetail',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchOddsGroupDetail: 'odds/fetchOddsGroupDetail',
      setLoadingDetail: 'odds/setLoadingDetail',
      addOddToCart: 'cart/addOddToCart',
    }),

    removeDetail(sourceEvent, type) {
      this.tab = null
      this.removeFromDetail({ source: sourceEvent, type: type })
    },

    async getOddsGroup(eventSource, groupId, sport, tournament) {
      if (groupId != this.groupSelected) {
        this.groupSelected = groupId
        this.tab_loading = true
        await this.setLoadingDetail({ status: true })

        await this.fetchOddsGroupDetail({
          source: eventSource,
          group: groupId,
          sport: sport,
          tournament: tournament,
        })

        await this.setLoadingDetail({ status: false })
        this.tab_loading = false
      }
    },

    async putCart(odd, event, sport, category, tournament) {
      if (odd.outcome_odd_value > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },

    getSpecifiers(spec) {
      let result = ''

      if (!spec) {
        return result
      }

      if (spec.includes('#')) {
        const split = spec.split('#')
        if (split[1].includes(':')) {
          result = '(' + split[1] + ')'
        } else if (split[1].includes('(') && split[1].includes('.')) {
          result = ' [' + split[1] + '] '
        } else if (split[1] != '') {
          result = split[1]
        }

        if (_.size(split) > 2) {
          return result + ' ' + split[2]
        } else {
          return result
        }
      } else {
        return result
      }
    },
    isActiveMarket(odds) {
      const check = _.find(odds, { active: true })
      if (check) {
        return true
      } else {
        return false
      }
    },
    checkExists(odds) {
      const check = _.find(odds, { showMarket: true })
      return !!check
    },
    checkHugeMarket(odds) {
      return _.size(odds) > 10 ? true : false
    },
    checkLocked(market) {
      const check = _.find(market.odds, { active: true })
      return !(market.odds.length > 8 && !check)
    },
  },

  async mounted() {
    this.groupSelected = 0
  },
  beforeDestroy() {},
}
</script>

<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}
</style>
